import type { RuleDefinition } from '../domain/types';
import { getCellText } from '../domain/cells';
import { getFieldDefinition } from '../domain/fields';
import { parseNumeric } from '../utils/number';
import { NUMERIC_FIELDS, cellValueForParsing, finding, isFormulaWithoutResult } from './helpers';

export const BQ007: RuleDefinition = {
  id: 'BQ007',
  name: '零值提醒',
  description: '提醒工程量、综合单价或合价为零的明细行。',
  defaultSeverity: 'warning',
  enabled: true,
  applicableFields: NUMERIC_FIELDS,
  message: '数值为零，请人工确认。',
  suggestion: '请核对零值是否为有意保留；确认无误后可关闭本规则。',
  check: ({ detailRows }) =>
    detailRows.flatMap((row) =>
      NUMERIC_FIELDS.flatMap((field) => {
        if (isFormulaWithoutResult(row, field)) return [];
        const parsed = parseNumeric(cellValueForParsing(row, field));
        if (!parsed.ok || !parsed.decimal.isZero()) return [];
        return [
          finding(row, field, {
            currentValue: getCellText(row, field),
            message: `${getFieldDefinition(field).label}为零。`,
          }),
        ];
      }),
    ),
};
